import { render, staticRenderFns } from "./adminClientCampaigns.vue?vue&type=template&id=307e0854&scoped=true&"
import script from "./adminClientCampaigns.vue?vue&type=script&lang=js&"
export * from "./adminClientCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./adminClientCampaigns.vue?vue&type=style&index=0&id=307e0854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307e0854",
  null
  
)

export default component.exports